module.exports = __webpack_public_path__ + "img/search-in-progress.7b6222a9.png";